// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"2084f89a","279":"baa63751","344":"f4356a9e","428":"d9f50a8c","932":"02fa6e6a"}[chunkId] + ".chunk.js";
};